/**
 * Shipping Calculator
 * 
 * Rules:
 * - Orders under £50: £2.95 flat rate
 * - Orders £50 and over: Free shipping
 */

export const SHIPPING_THRESHOLD = 50; // Free shipping threshold
export const SHIPPING_FLAT_RATE = 2.95; // Flat rate for orders under threshold

export interface ShippingResult {
  shippingCost: number;
  isFreeShipping: boolean;
  amountUntilFreeShipping: number;
  message: string;
}

/**
 * Calculate shipping cost based on order subtotal (after discounts)
 */
export function calculateShipping(subtotal: number): ShippingResult {
  const isFreeShipping = subtotal >= SHIPPING_THRESHOLD;
  const shippingCost = isFreeShipping ? 0 : SHIPPING_FLAT_RATE;
  const amountUntilFreeShipping = isFreeShipping ? 0 : Math.max(0, SHIPPING_THRESHOLD - subtotal);
  
  let message = '';
  if (isFreeShipping) {
    message = 'Free delivery';
  } else if (amountUntilFreeShipping <= 10) {
    message = `Add £${amountUntilFreeShipping.toFixed(2)} for free delivery`;
  } else {
    message = `Free delivery over £${SHIPPING_THRESHOLD}`;
  }
  
  return {
    shippingCost,
    isFreeShipping,
    amountUntilFreeShipping,
    message,
  };
}
